import React from 'react';

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Optional id for pairing with a `<label htmlFor>`. */
  id?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange, disabled = false, id }) => {
  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={e => {
        e.stopPropagation(); // Prevent event from bubbling to parent (row click)
        if (!disabled) {
          onChange(!checked);
        }
      }}
      style={{
        position: 'relative',
        width: '44px',
        height: '24px',
        borderRadius: '12px',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        backgroundColor: disabled
          ? checked
            ? 'var(--accent-primary)'
            : '#e2e8f0'
          : checked
            ? 'var(--accent-primary)'
            : '#cbd5e1',
        opacity: disabled && checked ? 0.7 : 1,
        transition: 'background-color 0.2s',
        padding: 0,
        outline: 'none',
      }}
      onMouseEnter={e => {
        if (!disabled) {
          e.currentTarget.style.opacity = '0.9';
        }
      }}
      onMouseLeave={e => {
        e.currentTarget.style.opacity = '1';
      }}
    >
      <span
        style={{
          position: 'absolute',
          top: '2px',
          left: checked ? '22px' : '2px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: '#ffffff',
          transition: 'left 0.2s',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
        }}
      />
    </button>
  );
};

export default ToggleSwitch;
